module.exports = __webpack_public_path__ + "static/media/icono_normativa.bdd20c2b.png";